import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
} from "@mui/material";
import SideBar from "./TeacherSidebar/TeacherSidebar";
import Navbar from "../../Header/header";

const CourseProgress = () => {
    const [grade, setGrade] = useState("");

    const handleGradeChange = (event) => {
        setGrade(event.target.value);
    };

    const courseData = [
        {
            id: 1,
            courseName: "Robotics & AI",
            lastClassDate: "10 February, 2025",
            class: "VI",
            assignedCourse: "Advance Robotics",
            progress: "9/36",
        },
        {
            id: 2,
            courseName: "Robotics & AI",
            lastClassDate: "10 February, 2025",
            class: "VII",
            assignedCourse: "Advance Robotics",
            progress: "9/36",
        },
        {
            id: 3,
            courseName: "Robotics & AI",
            lastClassDate: "10 February, 2025",
            class: "VIII",
            assignedCourse: "Advance Robotics",
            progress: "9/36",
        },
    ];

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body"></div>
                                <div style={{ padding: "20px" }}>
                                    <h2>Course Progress</h2>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Search..."
                                            style={{
                                                padding: "8px",
                                                borderRadius: "5px",
                                                width: "200px",
                                            }}
                                        />
                                        <FormControl
                                            variant="outlined"
                                            style={{ width: "200px" }}
                                        >
                                            <InputLabel>
                                                Select Grade
                                            </InputLabel>
                                            <Select
                                                value={grade}
                                                onChange={handleGradeChange}
                                                label="Select Grade"
                                                style={{ width: "200px" }}
                                            >
                                                <MenuItem value="VI">
                                                    VI
                                                </MenuItem>
                                                <MenuItem value="VII">
                                                    VII
                                                </MenuItem>
                                                <MenuItem value="VIII">
                                                    VIII
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>

                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>
                                                        Course Name
                                                    </TableCell>
                                                    <TableCell>
                                                        Last Class Date
                                                    </TableCell>
                                                    <TableCell>Class</TableCell>
                                                    <TableCell>
                                                        Assigned Course
                                                    </TableCell>
                                                    <TableCell>
                                                        Progress
                                                    </TableCell>
                                                    <TableCell>
                                                        Go to Course
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {courseData.map(
                                                    (course, index) => (
                                                        <TableRow
                                                            key={course.id}
                                                        >
                                                            <TableCell>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    course.courseName
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    course.lastClassDate
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {course.class}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    course.assignedCourse
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    course.progress
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                >
                                                                    Go to Course
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourseProgress;
